<template>
  <Menu
    width="160"
    theme="dark"
    class="sidebar"
    active-name="`${page.channelId}/${page.workspaceId}`"
    @on-select="selected"
    >
    <MenuGroup
      v-for="channel in orderByChannel(channels)"
      :key="channel.id"
      :title="channel.name"
      >
      <MenuItem
        v-for="w in orderByWorkspace(channel.workspaces)"
        :key="w.id"
        :name="`${channel.id}/${w.id}`"
        :to="`/dashboard/${channel.id}/${w.id}`"
        >
        <span :class="['item-name', { 'red': w.onair }]">
          {{ w.name }}
          <Icon
            v-show="w.onair"
            class="lamp"
            type="ios-radio-button-on"
            size="16"
            ></Icon>
        </span>
      </MenuItem>
    </MenuGroup>
  </Menu>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapState } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'channels'
    ]),
    page() {
      return this.$route.params
    }
  },
  methods: {
    selected(e) {
      this.$emit('hide-sidebar')
    },
    orderByChannel(channels) {
      return _.orderBy(channels, i => i.config.order)
    },
    orderByWorkspace(workspaces) {
      return _.orderBy(workspaces, i => i.config.order)
    }
  }
}
</script>

<style lang="less">

.sidebar {
  min-height: 100%;
  font-size: 12px;

  @keyframes blink {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }
  
  .lamp {
    padding: 0 0 3px 3px;
    animation: blink 1.5s ease-in-out infinite alternate;
  }

  .ivu-menu-vertical {
    .ivu-menu-item-group-title {
      height: 30px;
      padding-left: 10px;
      color: white;
      font-size: 12px;
      line-height: 30px;
      letter-spacing: 1px;
    }
  
    .ivu-menu-item {
      padding-left: 12px;
    }

  }

  .item-name {
    margin-left: 5px;
    font-size: 13px;
    font-weight: bold;
    color: white;
  }
  
  .ivu-menu-item-selected {
    color: #fff !important;
    font-weight: bold;
  }
}

</style>
